var map = {
	"./icons/Iconly/Light-Outline/Document.png": "4bd3",
	"./icons/icons": "57ac",
	"./icons/icons.js": "57ac",
	"./icons/logo": "5968",
	"./icons/logo.js": "5968",
	"./img/001.png": "3118",
	"./img/1-2.png": "1690",
	"./img/1.jpg": "38f3",
	"./img/1.png": "775a",
	"./img/2-2.png": "5214",
	"./img/2.png": "8e30",
	"./img/3.png": "1f66",
	"./img/3User.png": "c1ce",
	"./img/4.png": "5fa5",
	"./img/40px.png": "d0d6",
	"./img/5.png": "c037",
	"./img/6.png": "338d",
	"./img/67.png": "b3a0",
	"./img/7.png": "0f01",
	"./img/8.png": "eadf",
	"./img/9.png": "6846",
	"./img/A1.png": "275c",
	"./img/A2.png": "90f5",
	"./img/A3.png": "7146",
	"./img/A4.png": "d913",
	"./img/A5.png": "a6be",
	"./img/A6.png": "a81a",
	"./img/Avatar/Standard/40px.png": "cb0b",
	"./img/Avatar/Woman/1.png": "9adb",
	"./img/Avatar/Woman/2.png": "ad4a",
	"./img/BMW-logo.png": "7635",
	"./img/Banner1.png": "2bbc",
	"./img/BgPeople.png": "e055",
	"./img/Box.png": "28f3",
	"./img/Charts1.png": "0a39",
	"./img/ChatCircleDots.png": "dd99",
	"./img/DEFAULTBLOG.png": "1fba",
	"./img/DashboardFeedback.png": "f0be",
	"./img/DashboardInsight.png": "9142",
	"./img/DashboardReward.png": "7e0e",
	"./img/DefaultUser.png": "f0ec",
	"./img/Document.png": "7e29",
	"./img/Download.png": "5638",
	"./img/Ellipse 1.png": "3e4a",
	"./img/Ellipse 2.png": "1a6a",
	"./img/Ellipsedelete.png": "adc8",
	"./img/F1.png": "8ff7",
	"./img/F2.png": "3ce8",
	"./img/F3.png": "b0ac",
	"./img/F5.png": "1873",
	"./img/F6.png": "dac8",
	"./img/FBads.png": "fa3a",
	"./img/FeaturePic1.png": "c281",
	"./img/FeaturePic2.png": "b6ef",
	"./img/FeaturePic3.png": "9176",
	"./img/Filter.png": "4c44",
	"./img/Frame 1321314580.png": "afdf",
	"./img/GearSix.png": "3718",
	"./img/Google-icon.png": "7e76",
	"./img/Group.png": "c743",
	"./img/Icon1.png": "244c",
	"./img/Icon2.png": "d6bf",
	"./img/Icon3.png": "357d",
	"./img/Iconly/Curved/Plus.png": "43c7",
	"./img/Iconly/Light-Outline/Document.png": "ee24",
	"./img/Iconly/Light-Outline/Message.png": "45f5",
	"./img/Iconly/Light-Outline/Video.png": "c8fd",
	"./img/Iconly/Light/3User.png": "2b5b",
	"./img/Iconly/Light/Download.png": "1b83",
	"./img/Iconly/Light/Filter.png": "61a3",
	"./img/Iconly/Light/Video.png": "b695",
	"./img/Iconly/Plus2.png": "b9f6",
	"./img/Iconthunder.png": "7349",
	"./img/Illustration.png": "44ec",
	"./img/Illustration2.png": "e123",
	"./img/Illustration3.png": "244a",
	"./img/Indonesia.png": "abb1",
	"./img/Input.png": "1647",
	"./img/Interviewerr White.png": "cb39",
	"./img/LAYER.png": "f119",
	"./img/Lhitam.png": "6871",
	"./img/Line.png": "75bc",
	"./img/LocationWhite.png": "00dc",
	"./img/Logo(1).png": "2964",
	"./img/Logo(2).png": "01ee",
	"./img/Logo(3).svg": "cc34",
	"./img/Lputih.png": "af039",
	"./img/Lputih.svg": "4c7f",
	"./img/MSME.svg": "b394",
	"./img/Malaysia.png": "344a",
	"./img/Map.png": "edb1",
	"./img/Maskgroup.png": "fe40",
	"./img/Message.png": "f161",
	"./img/Or.png": "7923",
	"./img/Phone.png": "22ac",
	"./img/PhoneCall.png": "8e6f",
	"./img/Plumbing.png": "a44a",
	"./img/Plus.png": "860e",
	"./img/Plus2.png": "c1f3",
	"./img/PlusThin.png": "e037",
	"./img/ProfilePic1.png": "fb9e",
	"./img/ProfilePic2.png": "fc3d",
	"./img/ProfilePic3.png": "3036",
	"./img/ProfilePic4.png": "b8d0",
	"./img/ProfilePic5.png": "0a28",
	"./img/ProfilePic6.png": "48af",
	"./img/ProfilePic7.png": "c443",
	"./img/ProfilePic8.png": "ddc3",
	"./img/RegisterApp2.png": "d44c",
	"./img/RegisterApp3.png": "af3a",
	"./img/RegisterImg.png": "02f0",
	"./img/SG.png": "868c",
	"./img/Scan copy.png": "ec62",
	"./img/Screen 1.png": "f44a",
	"./img/Section.png": "d3ec",
	"./img/SectionPurple.png": "1be0",
	"./img/Sharts/Charts 1.png": "293f",
	"./img/Show.png": "1aab",
	"./img/Sign.png": "6986",
	"./img/SocialMedia.png": "b794",
	"./img/Spinner-3.gif": "e05f",
	"./img/StarRate.png": "9645",
	"./img/Thailand.png": "0aa6",
	"./img/TrendUp.png": "b63c",
	"./img/Trendingdown.svg": "ad35",
	"./img/US.png": "92a3",
	"./img/Video 2.png": "4205",
	"./img/Video 3.png": "7dfd",
	"./img/Video 4.png": "fbc0",
	"./img/Video 5.png": "6201",
	"./img/Vietnam.png": "c04e8",
	"./img/Voice.png": "02ef",
	"./img/Welcome.png": "75ec",
	"./img/add.png": "1d89",
	"./img/aivideo.png": "c559",
	"./img/aladdin.png": "2610",
	"./img/apple.png": "4977",
	"./img/appstore.png": "c460",
	"./img/arrow-left.png": "15c5",
	"./img/arrow-narrow-right.png": "c550",
	"./img/arrow-right black.png": "3d59",
	"./img/arrow-right-no-border.png": "ea38",
	"./img/arrow-right.png": "e9c1",
	"./img/arrow-top.png": "f25c",
	"./img/arrow.png": "5a8f",
	"./img/arrowdown": "d9a1",
	"./img/arrowdown-black.png": "78cf",
	"./img/arrowdown.jpg": "23ce",
	"./img/arrowdown.png": "0066",
	"./img/arrowup-black.png": "5e89d",
	"./img/avatar.png": "690a",
	"./img/b1.png": "ca849",
	"./img/b2.png": "36dd",
	"./img/b3.png": "348e",
	"./img/b4.png": "2c79",
	"./img/b5.png": "bf9c",
	"./img/b6.png": "ab6f",
	"./img/banner-img1.png": "3805",
	"./img/banner-img2.png": "bac4",
	"./img/banner-voucher.png": "a513",
	"./img/banner.png": "d22d",
	"./img/bannerPeople.png": "f083",
	"./img/bannerUser.png": "18ec",
	"./img/bell.png": "aefd",
	"./img/bg.png": "dc97",
	"./img/bgAbout.png": "6736",
	"./img/bgBluesquare.png": "503e",
	"./img/bgPurpleYellow.png": "ddbb",
	"./img/bgPurplerectangle.png": "4b93",
	"./img/bgapp.png": "8c6e",
	"./img/bggenie.png": "38f0",
	"./img/bgline.png": "5a03",
	"./img/bgloginsport.png": "3c1e",
	"./img/bgphone.png": "4607",
	"./img/bgsecond.png": "955b",
	"./img/bgsignin.png": "8356",
	"./img/bgthird.png": "8593",
	"./img/blue-info.png": "e476",
	"./img/bos": "8d46",
	"./img/bos.jpg": "f948",
	"./img/bos.png": "805b",
	"./img/bos1.png": "c8c6",
	"./img/brand1.png": "7605",
	"./img/brand2.png": "19e5",
	"./img/brand3.png": "8340",
	"./img/brand4.png": "11c8",
	"./img/brand5.png": "6523",
	"./img/brand6.png": "2c9f",
	"./img/brand7.png": "e302",
	"./img/briefcase.png": "f2f5",
	"./img/briefcase1.png": "324f",
	"./img/btn.png": "2e0f",
	"./img/btnNext.png": "1127",
	"./img/calendar-icon.png": "a915",
	"./img/calendar.png": "401b",
	"./img/camera.png": "97670",
	"./img/candidate.png": "fa62",
	"./img/car1.png": "4e44",
	"./img/car2.png": "d968",
	"./img/car3.png": "6557",
	"./img/car4.png": "9205",
	"./img/car5.png": "32bc",
	"./img/car6.png": "62d4",
	"./img/card.png": "0158",
	"./img/card2.png": "64e6",
	"./img/card3.png": "fb8c",
	"./img/card4.png": "de7f",
	"./img/ch.png": "a18c",
	"./img/check-white.png": "3f00",
	"./img/check.png": "06fb",
	"./img/checked.png": "1442",
	"./img/chevron-down.png": "6a70",
	"./img/chevron-up.png": "a2f0",
	"./img/claim-reward-screen.png": "4ceb",
	"./img/clean.png": "8b67",
	"./img/cleaning.png": "33d8",
	"./img/client1.png": "6200",
	"./img/client2.png": "b63a",
	"./img/client3.png": "68d4",
	"./img/client4.png": "6782",
	"./img/client5.png": "e69c",
	"./img/client6.png": "d0f9",
	"./img/client7.png": "a9fc",
	"./img/client8.png": "e8c8",
	"./img/close.png": "04b3",
	"./img/code.png": "f45d",
	"./img/codepen-purple.png": "d6fb",
	"./img/codepen.png": "bcaa",
	"./img/codesandbox.png": "70b9",
	"./img/company.png": "bafa",
	"./img/confirm.png": "4f75",
	"./img/congrate.png": "c182",
	"./img/copy-white.png": "8e91",
	"./img/copy.png": "e61d",
	"./img/copy2.png": "8849",
	"./img/country.png": "baf6",
	"./img/d2.png": "2f11",
	"./img/dashboard-card.png": "fc0e",
	"./img/dashbord-interviewrr.png": "3101",
	"./img/defaultbanner.png": "63e7",
	"./img/defaultteam.png": "f149",
	"./img/defaultusercartoon.png": "d970",
	"./img/delete.png": "fd6f",
	"./img/delete2.png": "be4c",
	"./img/detail.png": "152c",
	"./img/discount-shape copy.png": "3e09",
	"./img/discount-shape.png": "d669",
	"./img/doc.png": "fa64",
	"./img/document-like.png": "54a4",
	"./img/document-upload.png": "382e",
	"./img/dr1.png": "05fb",
	"./img/earth.png": "0ddb",
	"./img/easyredeem.png": "c5f9",
	"./img/edit.png": "162a",
	"./img/electric.png": "e298",
	"./img/element-4.png": "e229",
	"./img/element1.png": "d25a",
	"./img/element2.png": "e602",
	"./img/email.png": "8608",
	"./img/emailRound.png": "152a",
	"./img/error.png": "b948",
	"./img/export.png": "4b00",
	"./img/faris.png": "cf3b",
	"./img/fb.png": "2369",
	"./img/feature-gridbg.png": "7f0e",
	"./img/ford-logo.png": "3596",
	"./img/free-voucher.png": "d8c4",
	"./img/genie.png": "5357",
	"./img/geniegroup.png": "9ed0",
	"./img/gift copy.png": "56aa",
	"./img/gift-icon.png": "07ce",
	"./img/gift.png": "4ef4",
	"./img/google-symbol1.png": "6daf3",
	"./img/google.png": "3c62",
	"./img/googleplay.png": "366f",
	"./img/h1.png": "222a",
	"./img/house.png": "ea9b",
	"./img/huge-icon/education/outline/quiz.png": "6829",
	"./img/icon-candidate.png": "4fd5",
	"./img/icon-client.png": "3c2e",
	"./img/icon-coming.png": "1ef2",
	"./img/icon-customer.png": "618c",
	"./img/icon-job.png": "84af",
	"./img/icon-user.png": "ef15",
	"./img/icon-voucher.png": "847a",
	"./img/icon.png": "f0fc",
	"./img/iconai.png": "6a18",
	"./img/iconblog.png": "0e67",
	"./img/iconcamera.png": "ae5a",
	"./img/iconcontact.png": "97a9",
	"./img/iconfile.png": "4c5c",
	"./img/iconlight.png": "a103",
	"./img/iconmentol.png": "4672",
	"./img/iconnoti.png": "1e1b4",
	"./img/iconrefine.png": "e1fc",
	"./img/iconstarnoti.png": "3fdf",
	"./img/iconstep1.png": "f835",
	"./img/iconstep2.png": "41f8",
	"./img/iconstep3.png": "122f",
	"./img/iconvoucher.png": "0498",
	"./img/id.png": "2b0e",
	"./img/imagePhone.png": "8fda",
	"./img/img1.png": "a497",
	"./img/img2.png": "5f56",
	"./img/img3.png": "92e1",
	"./img/imgVideo.png": "21cd",
	"./img/in.png": "a069",
	"./img/in1.png": "8b1a",
	"./img/indon.png": "aaf3",
	"./img/info-circle.png": "0359",
	"./img/info.png": "2226",
	"./img/interest.png": "287f",
	"./img/interviewrr.png": "158c",
	"./img/ira.png": "a75d",
	"./img/kia-logo.png": "b468",
	"./img/landing-layout-phone.png": "60ea",
	"./img/leftquote.png": "2784",
	"./img/line-gradient.png": "9915",
	"./img/linkedin.png": "d6f3",
	"./img/location 2.png": "2406",
	"./img/location.png": "9076",
	"./img/location1.png": "3c54",
	"./img/logo-yomaro.png": "5ed8",
	"./img/logo.png": "4ffd",
	"./img/logo3.png": "7cbd",
	"./img/logout.png": "221c",
	"./img/love-red.png": "79e5",
	"./img/love-white.png": "d771",
	"./img/mail.png": "61ba",
	"./img/mask.png": "eebf",
	"./img/meeting.png": "f4f8",
	"./img/mentol.png": "5f0f",
	"./img/menu-board.png": "c938",
	"./img/minus.png": "33bd",
	"./img/mockup-phone.png": "69d6",
	"./img/monitor-mobbile.png": "d2c3",
	"./img/mostpopular.png": "fd71",
	"./img/mostpopular1.png": "0422",
	"./img/multipleuser.png": "1680",
	"./img/my.jpg": "127c",
	"./img/my.png": "4fea",
	"./img/nadia.png": "2a4f",
	"./img/navigation/navigation/home.png": "3a52",
	"./img/navigation/navigation/notification.png": "bc16",
	"./img/navigation/navigation/search-normal.png": "947f",
	"./img/navigation/navigation/user.png": "7a16",
	"./img/new/3dot.png": "6e7c",
	"./img/new/Balance info/coin.png": "db70",
	"./img/new/Bookmark.png": "715d",
	"./img/new/Brand-Logo/b1.png": "34d5",
	"./img/new/Brand-Logo/b2.png": "5a08",
	"./img/new/Brand-Logo/tng.png": "a54b",
	"./img/new/Emails/email.png": "d85c",
	"./img/new/Facebook.png": "5b0f",
	"./img/new/Icon.png": "f199",
	"./img/new/Interface, Essential/phone.png": "654a",
	"./img/new/Meta.png": "c8b8",
	"./img/new/Object/onboarding1.png": "6486",
	"./img/new/Telegram.png": "8cf1",
	"./img/new/VUI/Static/Listening State.png": "a9a5",
	"./img/new/appear.png": "a8e6",
	"./img/new/arrow-black.png": "7278",
	"./img/new/arrow-right.png": "2c5d",
	"./img/new/b1.png": "dbae",
	"./img/new/b2.png": "27d8",
	"./img/new/banner1.png": "4aa8",
	"./img/new/banner2.png": "5f47",
	"./img/new/banner3.png": "17ed",
	"./img/new/beauty_survey.png": "4d20",
	"./img/new/bg-purple.png": "d346",
	"./img/new/bgLineCircle.png": "71bd",
	"./img/new/bgdiamond.jpeg": "24f2",
	"./img/new/call.png": "6510",
	"./img/new/call2.png": "e0d9",
	"./img/new/card-purple.png": "a5a5",
	"./img/new/claim1.png": "6722",
	"./img/new/claim2.png": "89b4",
	"./img/new/claim3.png": "9ec5",
	"./img/new/close.png": "0e15",
	"./img/new/coin.png": "6933",
	"./img/new/coin2.png": "7e83",
	"./img/new/crown.png": "323c",
	"./img/new/delete-red.png": "9fd3",
	"./img/new/delete.png": "eee6",
	"./img/new/diamond.png": "5cef",
	"./img/new/dot.png": "8da6",
	"./img/new/edit-icon.png": "70ca",
	"./img/new/edu.png": "f967",
	"./img/new/email.png": "502b",
	"./img/new/fb.png": "9f1c",
	"./img/new/fore.png": "9c696",
	"./img/new/frame.png": "6ef7",
	"./img/new/group.png": "20aa",
	"./img/new/help.png": "d16b",
	"./img/new/hospitality.png": "a5c7",
	"./img/new/icon-promo.png": "5668",
	"./img/new/icondashboard.png": "b049",
	"./img/new/iconother.png": "0f38d",
	"./img/new/instagram.png": "afa4",
	"./img/new/language.png": "cda7",
	"./img/new/link.png": "6cfe",
	"./img/new/live-video-card/elements/dot.png": "2d13",
	"./img/new/mastercard.png": "d3e3",
	"./img/new/message.png": "e969",
	"./img/new/navigation/navigation/setting.png": "5e18",
	"./img/new/nostar.png": "48e3",
	"./img/new/note.png": "bb76",
	"./img/new/noti-setting.png": "200a",
	"./img/new/noti.png": "4368",
	"./img/new/onboarding1.png": "0952",
	"./img/new/onboarding2.png": "a197",
	"./img/new/onboarding3.png": "ab37",
	"./img/new/onboarding4.png": "dc96",
	"./img/new/onboarding5.png": "ec44",
	"./img/new/onboarding6.png": "3c32",
	"./img/new/onboarding7.png": "f468",
	"./img/new/password.png": "14a0",
	"./img/new/phone.png": "680d",
	"./img/new/post.png": "e81b",
	"./img/new/post1.png": "6c4f",
	"./img/new/post2.png": "fc6d",
	"./img/new/post3.png": "5ce6",
	"./img/new/post4.png": "d45a",
	"./img/new/promo.png": "51a6",
	"./img/new/qr.png": "2012",
	"./img/new/re1.png": "f2d8",
	"./img/new/review1.png": "60ba",
	"./img/new/review2.png": "227b",
	"./img/new/scan.png": "ac01",
	"./img/new/services.png": "41f2",
	"./img/new/setting.png": "9e4d",
	"./img/new/shopping_survey.png": "b456",
	"./img/new/smallicon/arrow.png": "a710",
	"./img/new/smallicon/dot.png": "d633",
	"./img/new/smallicon/noti.png": "1bc7",
	"./img/new/smallicon/search.png": "0123",
	"./img/new/smallvideo.png": "d4ad",
	"./img/new/splash.png": "ed9c",
	"./img/new/splash2.jpg": "dcc9",
	"./img/new/star.png": "e266",
	"./img/new/starorange.png": "12f0",
	"./img/new/success-icon.png": "bd12",
	"./img/new/success.png": "6127",
	"./img/new/successfull.png": "7135",
	"./img/new/successpurple.png": "56ac",
	"./img/new/technical.png": "6019",
	"./img/new/ticket.png": "b589",
	"./img/new/tng.png": "7123",
	"./img/new/userprofile.png": "120f",
	"./img/new/userreview.png": "ddca",
	"./img/new/v1.png": "a755",
	"./img/new/v2.png": "bea1",
	"./img/new/video-icon.png": "eed0",
	"./img/new/video.png": "be71",
	"./img/new/video1.png": "faf4",
	"./img/new/video2.png": "c3a7",
	"./img/new/video3.png": "7f3e",
	"./img/new/video4.png": "5e13",
	"./img/new/video5.png": "5106",
	"./img/new/video6.png": "544a",
	"./img/new/visa.png": "0dd0",
	"./img/new/voucher.png": "6f27",
	"./img/new/vuesax/linear/coin2.png": "aca4",
	"./img/new/vuesax/linear/ticket.png": "46bc",
	"./img/no-voucher.png": "addc",
	"./img/no_img.png": "1a6ad",
	"./img/nurul.png": "277a",
	"./img/offered.png": "cac8",
	"./img/or1.png": "1b16",
	"./img/paginate.png": "db24",
	"./img/painted.png": "b36b",
	"./img/pc.png": "b5ce",
	"./img/personalization.png": "3ac0",
	"./img/phone-icon.png": "503a",
	"./img/phoneRound.png": "2d6e",
	"./img/phonemockup.png": "6567",
	"./img/pickiddo-logo.png": "e9d3",
	"./img/pickiddo.png": "b791",
	"./img/pink-info.png": "08d5",
	"./img/pizza1.png": "9074",
	"./img/playar.png": "eca9",
	"./img/playvideo.png": "56ee",
	"./img/pos1.jpg": "f83b",
	"./img/pos2.jpg": "ce05",
	"./img/pos3.jpg": "21bd",
	"./img/prestige-logo.png": "dca9",
	"./img/printer.png": "d35e",
	"./img/profile-2user.png": "ca8a",
	"./img/progressbar.png": "572c",
	"./img/purple-logo.png": "b2bf",
	"./img/q1.png": "c55e",
	"./img/qr-default.png": "3227",
	"./img/questionmark.png": "e405",
	"./img/quiz.png": "7f75",
	"./img/receipt-discount.png": "110a",
	"./img/redeem.png": "a8db",
	"./img/rightstar.png": "7f99",
	"./img/sayed.png": "e130",
	"./img/scan-barcode.png": "fbe9",
	"./img/scan-screen.jpg": "64c4",
	"./img/scan.png": "2431",
	"./img/search.png": "1e5e",
	"./img/searchbutton.png": "0572",
	"./img/share.png": "cff1",
	"./img/sign1.png": "18d3",
	"./img/signupwith.png": "ee5f",
	"./img/signwith.png": "c276",
	"./img/slider-black.png": "c75d",
	"./img/slider-blue.png": "4574",
	"./img/slider.png": "94ec",
	"./img/slider2.png": "abaf",
	"./img/sport.png": "c88d",
	"./img/star-grey.png": "2166",
	"./img/star-yellow.png": "874c",
	"./img/star.png": "ba5a",
	"./img/status-up.png": "6758",
	"./img/step1.png": "3e46",
	"./img/step2.png": "30be",
	"./img/step3.png": "9160",
	"./img/subscribe.png": "3782",
	"./img/success.png": "d284",
	"./img/successPopup.png": "48f0",
	"./img/successround.png": "102c",
	"./img/text.png": "ff45",
	"./img/tick-circle-purple.png": "e1d3e",
	"./img/tick-circle.png": "fef3",
	"./img/tiket-discount.png": "8bb0",
	"./img/timer.png": "f6cc",
	"./img/tita.png": "5364",
	"./img/toggle-chat.png": "72f1",
	"./img/tq.png": "1349",
	"./img/tw.png": "4289",
	"./img/tw1.png": "0033",
	"./img/twitter.png": "13a4",
	"./img/unchecked.png": "f64f",
	"./img/upload.png": "f325",
	"./img/uploadpicture.png": "dccc",
	"./img/us1.png": "d5cb",
	"./img/us2.png": "ef54",
	"./img/us3.png": "2e41",
	"./img/us4.png": "4c4c",
	"./img/us5.png": "0240",
	"./img/us6.png": "96bd",
	"./img/user-tick.png": "bedb",
	"./img/user.png": "0f71",
	"./img/user1.png": "7cb8",
	"./img/user2.png": "accd",
	"./img/userprofile.png": "7e01",
	"./img/userselect.png": "0afd",
	"./img/v1.png": "7215",
	"./img/v2.png": "20ab",
	"./img/v3.png": "1527",
	"./img/v4.png": "026b",
	"./img/v5.png": "0929",
	"./img/v6.png": "9ae6",
	"./img/v7.png": "36b5",
	"./img/v8.png": "252a",
	"./img/vid.png": "1a34",
	"./img/video-square.png": "4bbb",
	"./img/video.png": "1c04",
	"./img/videointerview.png": "a13d",
	"./img/videoteam.png": "450e",
	"./img/voucher1.png": "5908",
	"./img/voucher2.png": "2f7b",
	"./img/voucher3.png": "d897",
	"./img/voucher4.png": "55cb",
	"./img/voucher5.png": "34d9",
	"./img/voucher6.png": "8555",
	"./img/voucher7.png": "3283",
	"./img/voucher8.png": "12d5",
	"./img/vuesax/Iconly/Light-Outline/Show.png": "8a9f",
	"./img/vuesax/Iconly/Light-Outline/Video.png": "b5f7",
	"./img/vuesax/Iconly/Light/Voice.png": "1626",
	"./img/vuesax/TrendUp.png": "3c2c",
	"./img/vuesax/Welcome.png": "3ec6",
	"./img/vuesax/avatar.png": "7c0d",
	"./img/vuesax/bold/tick-circle.png": "67d9",
	"./img/vuesax/calendar.png": "56d9",
	"./img/vuesax/edit.png": "2af6",
	"./img/vuesax/feed.png": "d63e",
	"./img/vuesax/logout.png": "c0f4",
	"./img/vuesax/multipleuser.png": "b652",
	"./img/vuesax/offered.png": "c8c9",
	"./img/vuesax/outline/location.png": "7a44",
	"./img/vuesax/outline/location1.png": "5d0a",
	"./img/vuesax/outline/status-up.png": "2d33",
	"./img/vuesax/outline/timer.png": "c6e7",
	"./img/vuesax/vid.png": "0afa",
	"./img/wall.png": "b99c",
	"./img/wide.png": "a904",
	"./img/worker.png": "b141",
	"./img/yomaro-logo.png": "df8d",
	"./scss/_custom.scss": "083f",
	"./scss/_variables.scss": "fb51",
	"./scss/backgroundVector.png": "6f5e",
	"./scss/style.scss": "78a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";